import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../components.module';
import { AuditHistoryComponent } from './audit-history.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [AuditHistoryComponent],
  exports: [AuditHistoryComponent],
  imports: [CommonModule, SharedModule, ComponentsModule],
})
export class AuditHistoryModule {}
